// 265+25 = 290
export const INITIAL_SOL = 290;

export const API_ENDPOINTS = {
  JUPITER: 'https://api.jup.ag/price/v2?ids=So11111111111111111111111111111111111111112',
  EXCHANGE_RATES: '/api/exchange-rate'
};